import { buildActionNames } from 'modules/store/util';
import { REDIRECT_TYPES } from 'modules/common/constants';

const moduleName = 'common';

// Action Types
export const types = buildActionNames(moduleName, [
  'ERROR_LOG',
  'ERROR_SET',
  'ERROR_CLEAR',
  'GLOBAL_SPINNER_HIDE',
  'GLOBAL_SPINNER_SHOW',
  'URL_REDIRECT',
]);

// Initial state
export const initialState = {
  error: {},
  spinner: {
    show: false,
  },
};

const clearCommonError = () => ({
  type: types.ERROR_CLEAR,
  payload: {
    error: {},
  },
});

const hideGlobalSpinner = () => ({
  type: types.GLOBAL_SPINNER_HIDE,
  payload: {
    spinner: {
      show: false,
    },
  },
});

/**
 * Tracks errors in Kibana's 'message' queue.
 * @param {string} message - the message of the error you'd like tracked;
 */
const logError = ({ message }) => ({
  type: types.ERROR_LOG,
  payload: {
    message,
  },
});

// Accepts types 'relative', 'replace', and 'absolute'. Default: 'relative'
// Type 'replace' ignores app basename and uses window.location.assign()
// Type 'absolute' navigates to an absolute url
// Useful for routing between Single Page Apps.
const redirectToUrl = ({ history, url, type = REDIRECT_TYPES.relative }) => ({
  type: types.URL_REDIRECT,
  payload: {
    history,
    url,
    type,
  },
});

/**
 * Sets `application.common.error`, which is mapped to the `Dialog` rendered in the layout component
 * @param {string} error.heading - the heading of the error
 * @param {string} error.message - the content of the error. Use when there is only one error present
 * @param {boolean} error.noTitle - set to true to hide the title of the dialog
 * @param {object[]} error.errors - an array of objects representing a list of errors. Each error content
 * should be mapped to the `description` key in the object
 */
const setCommonError = ({ errors, heading, message, noTitle }) => ({
  type: types.ERROR_SET,
  payload: {
    error: {
      errors,
      heading,
      message,
      noTitle,
    },
  },
});

const showGlobalSpinner = () => ({
  type: types.GLOBAL_SPINNER_SHOW,
  payload: {
    spinner: {
      show: true,
    },
  },
});

export const actions = {
  clearCommonError,
  hideGlobalSpinner,
  logError,
  redirectToUrl,
  setCommonError,
  showGlobalSpinner,
};

const commonReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.ERROR_CLEAR:
    case types.ERROR_SET:
    case types.GLOBAL_SPINNER_HIDE:
    case types.GLOBAL_SPINNER_SHOW:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default commonReducer;
